import getWindow from "../utils/window";
import { isProductUnavailable } from "../../utils/productUtils";
let stockPriceResponse;

export default async function getStockPrice(product, retry) {
  if (isProductUnavailable(product)) {
    return [];
  }

  if (getWindow() && (!stockPriceResponse || retry)) {
    stockPriceResponse = getWindow().asos.pdp.getStockPrice(retry);
  }

  return stockPriceResponse;
}
